<template>
  <div class="container">
    <b-progress class="mb-2" :value="current_step - 1" variant="success" :max="3" show-progress animated></b-progress>
    <b-card header="Perekaman Barang Pindahan" class="Barpin" show-footer>
      <div slot="header" v-show="current_step == 1">
        <label class="float-right mt-3">
          <button class="btn btn-success" @click="simpan">
            <i class="fa fa-check"></i> Simpan
          </button>
        </label>
      </div>
      <loading :active.sync="this.$store.state.barpin.isLoading" :is-full-page="false"></loading>
      <component v-bind:is="currentStep"></component>
      <div slot="footer" class="d-flex justify-content-between">
        <button v-show="current_step > 1" type="button" class="btn btn-secondary" @click="current_step--">
          <i class="fa fa-arrow-left"></i> Back
        </button>
        <button type="button" class="btn btn-secondary ml-auto" v-show="current_step == 1" @click="current_step++">
          Next
          <i class="fa fa-arrow-right"></i>
        </button>
        <button type="button" class="btn btn-primary ml-auto" v-show="current_step == 2" @click="saveNext">
          Save and Next
          <i class="fa fa-arrow-right"></i>
        </button>
        <button type="button" class="btn btn-success ml-auto" v-show="current_step == 3" @click="kirim">
          Simpan dan Kirim
          <i class="fa fa-send"></i>
        </button>
      </div>
    </b-card>
    <b-modal title="Keterangan Gagal Kirim" v-model="modalError">
      <ul>
        <li v-for="(error, index) in reject" :key="index">{{ error }}</li>
      </ul>
    </b-modal>
  </div>
</template>

<script>
import Step1 from './perekaman/Step-1'
import Step2 from './Perekaman/Step-2'
import Step3 from './Perekaman/Step-3'
import swal from 'sweetalert'
import {mapActions} from 'vuex'
export default {
  components: {
    Step1,
    Step2,
    Step3
  },
  data () {
    return {
      current_step: 1,
      reject: [],
      modalError: false
    }
  },
  created () {
    this.$store.dispatch('barpin/getData', this.$route.params.id).then(() => {
      if (this.$store.state.barpin.header.kd_status === 100 || this.$store.state.barpin.header.kd_status === 190) swal('error', 'Status bukan perekaman', 'error').then(() => this.$router.push('../browse'))
    })
  },
  methods: {
    ...mapActions({
      save: 'barpin/saveData'
    }),
    simpan () {
      const npwpRegex = /^[0-9]{16}$/
      if (this.$store.state.barpin.header.jns_identitas === '5' && !npwpRegex.test(this.$store.state.barpin.header.no_identitas)) {
        swal('error', 'NPWP harus 16 digit', 'error')
        return
      }
      if (this.$store.state.barpin.header.jns_identitas_kuasa === '5' && this.$store.state.barpin.header.fl_kuasa && !npwpRegex.test(this.$store.state.barpin.header.no_identitas_kuasa)) {
        swal('error', 'NPWP Kuasa harus 16 digit', 'error')
        return
      }
      swal({
        title: 'Simpan data?',
        text: 'Anda yakin akan menyimpan?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.save(this.$route.params.id).then(() => {
                swal('success', 'Berhasil menyimpan', 'success')
              }).catch((error) => {
                swal('error', JSON.parse(error.bodyText).message, 'error')
              })
          }
        })
    },
    saveNext () {
      const npwpRegex = /^[0-9]{16}$/
      if (this.$store.state.barpin.header.jns_identitas === '5' && !npwpRegex.test(this.$store.state.barpin.header.no_identitas)) {
        swal('error', 'NPWP harus 16 digit', 'error')
        return
      }
      if (this.$store.state.barpin.header.jns_identitas_kuasa === '5' && this.$store.state.barpin.header.fl_kuasa && !npwpRegex.test(this.$store.state.barpin.header.no_identitas_kuasa)) {
        swal('error', 'NPWP Kuasa harus 16 digit', 'error')
        return
      }
      swal({
        title: 'Simpan data?',
        text: 'Anda yakin akan menyimpan?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.save(this.$route.params.id).then(() => {
                swal('success', 'Berhasil menyimpan', 'success').then(() => {
                  this.current_step++
                })
              }).catch((error) => {
                swal('error', JSON.parse(error.bodyText).message, 'error')
              })
          }
        })
    },
    kirim () {
      const npwpRegex = /^[0-9]{16}$/
      if (this.$store.state.barpin.header.jns_identitas === '5' && !npwpRegex.test(this.$store.state.barpin.header.no_identitas)) {
        swal('error', 'NPWP harus 16 digit', 'error')
        return
      }
      if (this.$store.state.barpin.header.jns_identitas_kuasa === '5' && this.$store.state.barpin.header.fl_kuasa && !npwpRegex.test(this.$store.state.barpin.header.no_identitas_kuasa)) {
        swal('error', 'NPWP Kuasa harus 16 digit', 'error')
        return
      }
      swal({
        title: 'Kirim data?',
        text: 'Anda yakin akan mengirim pengajuan ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.$store.commit('barpin/SET_LOADING', true)
              this.save(this.$route.params.id).then(() => {
                this.$http.post('ppftz/send', {ID_AJU: this.$store.state.barpin.header.id_aju}).then(() => {
                  this.$store.commit('barpin/SET_LOADING', false)
                  swal('success', 'Berhasil menyimpan', 'success').then(() => {
                    this.$router.push('../browse')
                  })
                }).catch((error) => {
                  console.log(error)
                  if (error.status === 400) {
                    this.reject = error.data
                    this.modalError = true
                    // swal('error', JSON.stringify(error.data), 'error')
                    return
                  }
                  swal('error', JSON.parse(error.bodyText).message, 'error')
                  // this.$store.commit('barpin/SET_LOADING', false)
                })
              }).catch((error) => {
                swal('error', JSON.parse(error.bodyText).message, 'error')
              })
          }
        })
    }
  },
  computed: {
    currentStep () {
      return `Step-${this.current_step}`
    }
  }
}
</script>
<style>
.Barpin {
  min-height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/views/ppftz/Perekaman.vue?512a5b66